/**
 * We keep z-indexes in one place so we can see their dependencies and avoid conflicts.
 *
 * Keys are stacking layers (not feature names). Same numeric band → one key, reused across features.
 *
 * Stacking (low → high): base (1) → anchored (2) → anchoredControl (3) → raised (5) → page controls / overlay (11–12) →
 * fixed navigation (30–31) → dismissible overlays (32–33) → listing/property modals (100+).
 * Gaps between bands are intentional buffers so a new mid-layer can land without renumbering everything above it.
 *
 * - base (1) — default in-flow stacking
 * - anchored (2) — sticky columns and labels within scroll containers
 * - anchoredControl (3) — controls on anchored columns (drag handles, action buttons)
 * - raised (5) — pseudo-overlays and highlights above local siblings (drop targets, row overlays)
 * - pageControl (10) — sticky in-page chrome and floating scroll controls
 * - indicator (20) — insertion / drop guides (column reorder line, etc.)
 * - overlay / elevated (11–12) — in-page chrome below fixed navigation (badges, card controls, etc.)
 * - navigationChrome / navigationProfileMenu (30–31) — fixed app navigation
 * - pageOverlay / pageOverlayContent (32–33) — fullscreen dismiss overlays and their panels
 *   (sort dropdown, property action menus, …). Must sit above navigation so dimming / outside-click
 *   covers the chrome too.
 *
 * Listing modal stack:
 * - listingModal (100) — base recommendation/discussion detail modal
 * - listingModalNavigation (101) — chrome inside that modal
 * - nestedModal (110) — modals opened above the base listing modal
 * - topModal (120) — modals / overlays above nested ones
 *
 * Those values are also configured in pandacss config, as global vars,
 * so you can use them like "var(--zIndex-listingModalNavigation)"
 */

export const zIndexes = {
    base: 1,
    anchored: 2,
    anchoredControl: 3,
    raised: 5,
    pageControl: 10,
    overlay: 11,
    elevated: 12,
    indicator: 20,
    navigationChrome: 30,
    navigationProfileMenu: 31,
    pageOverlay: 32,
    pageOverlayContent: 33,
    listingModal: 100,
    listingModalNavigation: 101,
    nestedModal: 110,
    topModal: 120,
    // Above the RP landing header (2001, 2002 with the mobile menu open). SMS and the auth dialog stay on the design-system default, 9000.
    landingOverlay: 2100,
    // Max 32-bit int — must stay above all KM modals and match @pg-mono/turnstile widget container z-index.
    turnstileChallengeModal: 2147483647
};
/**
 * We keep z-indexes in one place so we can see their dependencies and avoid conflicts.
 *
 * Keys are stacking layers (not feature names). Same numeric band → one key, reused across features.
 *
 * Stacking (low → high): base (1) → anchored (2) → anchoredControl (3) → raised (5) → page controls / overlay (11–12) →
 * fixed navigation (30–31) → dismissible overlays (32–33) → listing/property modals (100+).
 * Gaps between bands are intentional buffers so a new mid-layer can land without renumbering everything above it.
 *
 * - base (1) — default in-flow stacking
 * - anchored (2) — sticky columns and labels within scroll containers
 * - anchoredControl (3) — controls on anchored columns (drag handles, action buttons)
 * - raised (5) — pseudo-overlays and highlights above local siblings (drop targets, row overlays)
 * - pageControl (10) — sticky in-page chrome and floating scroll controls
 * - indicator (20) — insertion / drop guides (column reorder line, etc.)
 * - overlay / elevated (11–12) — in-page chrome below fixed navigation (badges, card controls, etc.)
 * - navigationChrome / navigationProfileMenu (30–31) — fixed app navigation
 * - pageOverlay / pageOverlayContent (32–33) — fullscreen dismiss overlays and their panels
 *   (sort dropdown, property action menus, …). Must sit above navigation so dimming / outside-click
 *   covers the chrome too.
 *
 * Listing modal stack:
 * - listingModal (100) — base recommendation/discussion detail modal
 * - listingModalNavigation (101) — chrome inside that modal
 * - nestedModal (110) — modals opened above the base listing modal
 * - topModal (120) — modals / overlays above nested ones
 *
 * Those values are also configured in pandacss config, as global vars,
 * so you can use them like "var(--zIndex-listingModalNavigation)"
 */

export const zIndexes = {
    base: 1,
    anchored: 2,
    anchoredControl: 3,
    raised: 5,
    pageControl: 10,
    overlay: 11,
    elevated: 12,
    indicator: 20,
    navigationChrome: 30,
    navigationProfileMenu: 31,
    pageOverlay: 32,
    pageOverlayContent: 33,
    listingModal: 100,
    listingModalNavigation: 101,
    nestedModal: 110,
    topModal: 120,
    // Above the RP landing header (2001, 2002 with the mobile menu open). SMS and the auth dialog stay on the design-system default, 9000.
    landingOverlay: 2100,
    // Max 32-bit int — must stay above all KM modals and match @pg-mono/turnstile widget container z-index.
    turnstileChallengeModal: 2147483647
};
